import { routes } from "routes";

export const feedbackReportsListRoute = () =>
  `${routes.DEVELOPERS}/${routes.FEEDBACK}`;

export const feedbackReportRoute = (uuid: UUID) =>
  `${feedbackReportsListRoute()}/${uuid}`;
